import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'rubrica_soggetti';

const getSoggetti = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "get_rubrica" , data: params}, callback);

const apiEndpoint = {
  getSoggetti
}

export default apiEndpoint;